'use strict';

var login = function () {

	var _clearError = function _clearError() {
		var $inputs = $('input');
		var $errorElem = $('.error');

		$inputs.on('focus', function () {
			$errorElem.removeClass('visible').html('');
		});
	};

	var _validate = function _validate(errorMsg) {
		var form = document.forms.login;
		var pError = document.getElementsByClassName('error')[0];

		form.addEventListener('submit', function (event) {
			event.preventDefault();
			var vLogin = form.elements.user.value;
			var vPassword = form.elements.password.value;
			if (vLogin.trim().length === 0 || vPassword.trim().length === 0) {
				pError.className = 'error visible';
				pError.innerHTML = errorMsg;
				return false;
			} else {
				sessionStorage.myId = vLogin + vPassword;
				sessionStorage.code = vLogin;
				form.submit();
			}
		});
	};

	var _init = function _init(errorMsg) {

		sessionStorage.clear();

		_validate(errorMsg);

		_clearError();
	};

	return {
		init: _init
	};
}();